module.exports = __webpack_public_path__ + "img/phpExpressLogo.01b9922.webp";